// extracted by mini-css-extract-plugin
export default {"paymentPrediction":"PaymentPrediction_paymentPrediction__yT3N2"};